import React, {useState} from "react";
import {Form, Input} from "antd";
import {FormattedMessage} from "react-intl";
import {validVideoFileExtensions} from "@components/video-files/core/validFileExtensions";
import transcoding from '@api/transcoding'
import {validAudioFileExtensions} from "./core/validFileExtensions";


const AudioInout = ({form, audios, addFile}) => {

  const validateFtpPath = (rule, value, callback) => {
    const path = value.trim();
    if (!!path) {
      const extention = path.split(".").pop()
      if (audios.find(item => item.path === path)) {
        callback(
          <FormattedMessage
            id="audios_is_added"
            defaultMessage={`Audio has been added`}/>);
      }
      else if (!validAudioFileExtensions.includes(extention)) {
        callback(
          <FormattedMessage
            id="invalid_audio_file_extension"
            defaultMessage={`File extension is invalid!`}/>);
      }
      else {
        transcoding.getFile({params: {path}})
          .then(({data}) => {
            addFile(data.audios.map(item => ({...item, path})))
            form.resetFields()
            if (!data) {
              callback(
                <FormattedMessage
                  id="app.invalid_file_path"
                  defaultMessage={`File path is invalid`}/>);
            } else {
              callback();
            }
          })
          .catch(error => callback(<FormattedMessage
            id="app.invalid_file_path"
            defaultMessage={`File path is invalid`}/>));
      }

    } else {
      callback();
    }
  };

  return (
    <Form style={{padding: "10px"}}>
      <Form.Item label={<FormattedMessage
        id="add_audio"
        defaultMessage={`Add audio`}/>}>
        {form.getFieldDecorator("relative_ftp_path", {
          rules: [{
            whitespace: true,
            required: true,
            message: (
              <FormattedMessage
                id="app.ftp_path_is_required"
                defaultMessage={`FTP path is required`}
              />
            )
          }, {
            validator: validateFtpPath
          }]
        })(
          <Input className={"url-input"}/>
        )}
      </Form.Item>
    </Form>
  )
}


export default Form.create({name: "audio-file-input"})(AudioInout)

